<template>
  <div>

    <b-card>
      <!-- <b-row>
        <b-col
          md="8"
          class="d-flex align-items-center justify-content-start"
        >
          <b-col
            cols="12"
            md="3"
            class="pl-0"
          >
            <v-select
              v-model="query.deskContractId"
              :options="codes.validContracts"
              placeholder="계약명"
              :reduce="option => option.code"
            />
          </b-col>

          <b-form-input
            v-model="query.title"
            class="el-def"
            placeholder="제목"
            style="width:60%;"
          />

        </b-col>

        <b-col
          md="4"
          class="d-flex align-items-center justify-content-end"
        >
          <b-button
            variant="primary"
            class="btn-search"
            @click.prevent="fetchData()"
          >
            조회
          </b-button>

        </b-col>

      </b-row> -->

      <content-list />

    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import {
  ref, watch, onMounted, getCurrentInstance,
} from "@vue/composition-api"
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import dayjs from 'dayjs'
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import ContentList from './list/ContentList.vue'

export default {
  components: {
    ContentList,
  },

  setup() {
    onMounted(() => {
      // fetchCodes()
    })

    const toast = useToast()
    const instance = getCurrentInstance()
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    return {
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.dropdown-menu {
  z-index: 100 !important;
}
</style>
